<template>
  <div class="register container">
    <PageHeading heading="Officials Registration"/>
    <br/>
    <div class="row alert confirmation alert-success" v-if="success">
      <div class="col-12">
          <h4>You registered the following:</h4>
      </div>
      <div class="col-md-3">
        <div class="container">
          <strong>Name:</strong> {{ official.name }} <br/>
        </div>
      </div>
    </div>

    <form class="row" ref="form" v-if="!success">
      <!-- BEGIN FIRST COLUMN OF FORM -->
      <div class="col-md-12 team">
        <div class="row g-3">
          <!-- Date -->
          <div class="col-md-3">
            <label for="date" class="form-label">Date <span>(REQUIRED)</span></label>
            <select id="date" class="form-select" v-model="official.date">
              <option disabled value="">Select a date</option>
              <option v-for="date in dates" :key="date.id" :value="date.date">{{fmtDate(date.date)}} at {{date.location}}</option>
            </select>
          </div>
            
          <!-- Name -->
          <div class="col-md-3">
            <label for="name" class="form-label">Name <span class="red" v-if="required(validName)">(REQUIRED)</span></label>
            <input type="text" class="form-control" id="name" v-model="official.name" :class="validName">
          </div>

          <!-- Email -->
          <div class="col-md-4">
            <label for="email_address" class="form-label">Email <span class="red" v-if="required(validEmail)">(REQUIRED)</span></label>
            <input type="email" class="form-control" id="email_address" v-model="official.email" :class="validEmail">
          </div>
        </div><!-- END FIRST ROW OF FORM-->
        <br/>
        <div class="row g3">
          
          <div class="col-md-4">
            <label for="email_address" class="form-label">Divisions <span class="red">(SELECT ALL THAT APPLY)</span></label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="novice" v-model="official.divisions.novice">
              <label class="form-check-label" for="novice">Novice</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="intermediate" v-model="official.divisions.intermediate">
              <label class="form-check-label" for="intermediate">Intermediate</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="advanced" v-model="official.divisions.advanced">
              <label class="form-check-label" for="advanced">Advanced</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="expert" v-model="official.divisions.expert">
              <label class="form-check-label" for="expert">Expert</label>
            </div>
          </div>
          
          <div class="col-md-4">
            <label for="email_address" class="form-label">Roles <span class="red">(SELECT ALL THAT APPLY)</span></label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="quiz_master" v-model="official.roles.qm">
              <label class="form-check-label" for="quiz_master">Quiz Master</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="score_keeper" v-model="official.roles.sk">
              <label class="form-check-label" for="score_keeper">Score Keeper</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="content_judge" v-model="official.roles.cj">
              <label class="form-check-label" for="content_judge">Content Judge</label>
            </div>
          </div>
          
        </div>
      </div><!-- END ROW OF FIRST COLUMN -->
    </form>
    <div class="d-grid gap-2">
      <button class="btn btn-dark" type="button" @click="register" v-if="!success" :disabled="!formComplete">Register</button>
      <button class="btn btn-success" type="button" @click="registerNew" v-if="success">Register Another Official</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios"
import PageHeading from '@/components/PageHeading.vue';

export default {
  name: 'Officials',
  components: {
    PageHeading
  },
  data: function() {
    return {
      official: {
        name: '',
        email: '',
        divisions: {'novice':false, 'intermediate':false, 'advanced':false,'expert':false},
        roles: {'qm':false, 'sk':false, 'cj':false, 'other':''},
        notes: '',
        date: ''
      },
      success: false,
      dates: []
    }
  },
  created() {
    // Get the schedule to populate the dates for registration 
    axios.get(process.env.VUE_APP_API_ROOT + "/lib/schedule.php")
    .then((response) => {
      if(response.data !== null) {
        this.dates = response.data.map (a => {return {date: a.date, location: a.location}});
        
        // Find the nearest future date
        this.official.date = this.findNearest();
      }
    });

  },
  computed: {
    formComplete: function() {
      const v = "is-valid";
      return  this.validName == v 
              && this.validEmail == v;
    },
    validName: function() {
      return  this.genericValidation(this.official.name);
    },
    validEmail: function() {
      // Stole this from Stackoverflow
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !this.isNotBlank(this.official.email) ? '' : re.test(String(this.official.email).toLowerCase()) ? 'is-valid' : 'is-invalid';
    }
  },
  methods: {
    isNotBlank: function(val) {
      return val && val.length > 0 ? true:false;
    },
    isValidName:  function(val,length) {
      return val && val.length >= length;
    },
    genericValidation: function(val) {
      return !this.isNotBlank(val) ? '' : this.isValidName(val,3) ? 'is-valid' : 'is-invalid';
    },
    required: function(val) {
      return val == "" || val == "is-invalid" ? true : false;
    },
    findNearest: function() {
      let now = new Date();
      // first set nearest date after 'now'
      let nearest = undefined;
      this.dates.forEach(function(d) {
       const date = new Date(d.date);
       if (date >= now) {
          nearest = d.date;
          now = new Date("2100-01-01"); // Can't break so make it impossible to come back into the block
        }
      })
      return nearest;
    },
    register: function() {
      console.log("official: " + this.official);
      axios.post(process.env.VUE_APP_API_ROOT + '/lib/register_officials.php', this.official)
                .then((res) => {
                    console.log(res.data);
                    this.success = true;
                })
                .catch((error) => {
                    console.log(error);
                });
    },
    registerNew: function() {
      this.official.name = '';
      this.official.email = '';
      this.official.notes = '';
      this.official.divisions = {'novice':false, 'intermediate':false, 'advanced':false,'expert':false};
      this.official.roles = {'qm':false, 'sk':false, 'cj':false, 'other':''};
      this.success = false;
    }
  }
}
</script>

<style>
label > span {
  font-size: 75%;
  color: rgb(122, 122, 122)
}
.red {
  color: rgb(155, 0, 0);
  font-weight: bold;
}
form  {
  padding: 0 1em;
}

.quizzer {
  border-radius: 5px;
  background-color: #FBFBFB;
  padding: .5em;
  margin: 1em auto;
}

.quizzers {
  padding-top: .5em;
  background-color: #F9F9F9;
  margin-bottom: 1em;
}

.team {
  padding-top: 1em;
  background-color: #FBFBFB;
  border-right: 2px dotted #DADADA; margin-bottom: 1em;
}

.confirmation {
  margin: 1em 0;
}

.confirmation .container {
  padding-left: .5em;
} 
</style>